import { render, staticRenderFns } from "./rt2.vue?vue&type=template&id=6da05a90&scoped=true&"
import script from "./rt2.vue?vue&type=script&lang=js&"
export * from "./rt2.vue?vue&type=script&lang=js&"
import style0 from "./rt2.vue?vue&type=style&index=0&id=6da05a90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da05a90",
  null
  
)

export default component.exports